const BASE = "https://static.prod-images.emergentagent.com/jobs/c83db367-e681-4b8f-af9c-207821eeead3/images/";

export const ANIME_AVATARS = [
  "4fd60029c210ee481bcf0d0d5a7edf68b27d91f064cd7f9aebb293d5a7499653",
  "f5d51e9af2cac309dd5f41e11ce8018ad7d223eb36abbab277063cf606b6b372",
  "da5dbf88269ab998aed6d872f02d2db64ae2276a4b52ac2a3d03852cc3607c68",
  "7561686e567a934cce86d2c219412677b10fe1ab4b516622cb955626fd2dec65",
  "b16908d0fd50a028dffdca4196de814af7081002980dc8149912398d5480eb0d",
  "a8f15f1cdede10a7c73bbb7f1a6c758ab248573676875cff35f2bacedbc90593",
  "f48ec0685094b6d78c34d53c988bee8c7a826d2953f5d05b7abfa71f55dce5b4",
  "6ef643923fbfef76e8ed00587d5f24efb45edfb2d5d5ee42de799eff6f61818d",
  "68a9a67e5ac583d1e2af68b6f7aef8bde751148c65beb290294dee8e0dd47831",
  "e5f353904cea1bd88746b7f176875520f9e1d93c599f7786dbe9b52ba9fcde24",
  "eab8e017373780f6eabeb06afc75562862ac4b010b04af815afd08633b8b860a",
  "fb70e08620a60012926a38339e7f9af3d69375e94eae9bd1fc8f29b1aa6197d3",
  "abe768385e30e48820e681d859ba74c416a42cc0e5da45a0ed2a59d3256c079a",
  "1dee5c0003a841d61f72b36f3d80e3ecce63548f0e2b762da37ae5dcd9df02ab",
  "df16a7691a2cea1b2d40162dcac34365c1ff212aac2963f916144f1fb7b12e83",
  "2146c48d5e091f0c9b3f6618f098c6dbd68a231299801bc56222ea5aea9b30dc",
  "51275f42c5158cc6ea912ce6508c77957c420a0f5657b51fdd3d15401577f072",
  "8b7c06477a059611ede01da6c13fbd87d7288dce16f0e8060f89b2c19dd5ef6d",
  "59ec8c261be6118a48992639e4d2af73c3702c0e0fe90ddf71ae6bb6dd5ca990",
  "4b9cc837ccdf3e9367ba7bc3823ecaa69f550dd2ebfbd766efa5d76a4761f999",
  "52b8d56355a3e843e377cb8bf79982532824f5c4c854374f28f376ef7a6d93ca",
  "648f3d16c11dd101b13e235a84b3f4aac638b45a5311989dba7ed1bc05322b76",
  "fd3786bbbbde47d1e93ad3069c6a0244c4da1f4871a6c383f7d5fd7c423e3d00",
  "117a4c5f80599668da146ed53803dd36f7e6c43b539520d3ef2fe10939d16c58",
  "813dfd03f06d47b40db79aa1ce58d9c3f030b86fb39c3717595b42c38767dd7c",
  "c20cfff7de79bb5727e10cde04537167090b6d85447458aaa12e572c3a884627",
  "19a5d8c5bac574af44b6fd02b436b2e0974945c24b69a087abbbba38ae88b37a",
  "babf41faa82724b8ef698588cf7df28208709ce989345b84b611d52ed367cf3e",
  "0127aca7622b02f36b787adbecc563d3caa5848cb5e566ddd65ea7674224bc3e",
  "2f67e4da73cd5ef4b1d8cbb4e7364dbd274c6fb84d0ae08a48d9d855caa7e0cb",
  "f2aa1ea4f6a39f809e6342c4fa4a1482e1cd21f7858b5da314ac6650d5914372",
  "0065544a627d46aadcc19c9b04659b19f861caa050db42d81c7225c57b5aeca0",
  "4bab3a1e544b4ccfe1be9c58b92f57c21742aeee9072b08bd40e1e0e3fa39adf",
  "cd30363b85268773515ad257c795bd5067faa505f9ad485bc60019be763e7c3b",
  "d0c702ce28b202e4be79e7b0d7bf05346413f800af630bc51705838557123508",
  "a5350041c7101121dc4ca24a3b531af9e57c843a0edef716f343b70835354b79",
  "eb527e4aa7c00265fd9a6bcaf68d88e614a50a4b2746c56789ab24610bcac6d8",
  "dcb35d9c2b52275f69a351072d42c9a91cb071713bc3b2d1cfdd06d5b7517168",
  "05ff94f5e25eccbc3515b53b20c5ac6d512eb0115f6788adea34abc48ee8cfba",
  "ccac476f6207e2453ded965b30655a97ebf0be7a8a42c45e99d22f94060495f9",
  "11ca68db443c1b4639b33aab2693d4f24e1a542314425d8f59f40f4824366b23",
  "0c5c5a82111de49e5fbfe37772b5f0787ecb3a74110b99c5b8876b3a7a49b1cd",
  "a4e3df08119fda035ead1ea5b95a03d8700d4ccadbac91fe1ead703c4f8db6e9",
  "c1e54c93fff681cc89236225d2fea5fa77aa93124448580526d709ff94667fc5",
  "b85135c242684b2b4853795217d37f41924d73d3bb1e096486ebc730a68e8950",
  "30bfe64f07a9fb37cb4739211b0a2840dd8721691e68560e7aeb9fe5c45171a5",
  "0ba3162ecd482fd1b51ac86e11486bbda02ef5ffd17cd554a0c1576a8d2e9f94",
  "9d5872e7e807b8bff4242785ab76e9ef0b10aafc9b1870d7783a2b64d2aab88a",
  "02a227afbe21d1bdd8a1d2519358dd5b81526cdad4bae993916e282de9ba5500",
  "b1b80fbe01a13eeafc44d381e4d91c898d0fef9c19108c620857aace94fc937b",
].map((h) => `${BASE}${h}.png`);
